module.exports = __webpack_public_path__ + "img/app-native.9ac401f3.svg";